import { Link } from 'react-router-dom';
import { track } from '../utils/umami';

export const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-brand">
        <h3>Lunetterie du Russey</h3>
        <p>Excellence artisanale depuis 18 ans</p>
      </div>
      <div className="footer-links">
        <a href="tel:0381679020" onClick={() => track('clic-telephone', { source: 'footer' })}>03 81 67 90 20</a>
        <span>·</span>
        <a href="mailto:lunetteriedurussey@gmail.com" onClick={() => track('clic-email', { source: 'footer' })}>Contact</a>
        <span>·</span>
        <a href="https://www.facebook.com/Lunetteriedurussey/" target="_blank" rel="noopener noreferrer" onClick={() => track('clic-reseau-social', { reseau: 'facebook', source: 'footer' })}>Facebook</a>
        <span>·</span>
        <a href="https://www.instagram.com/lunetteriedurussey/" target="_blank" rel="noopener noreferrer" onClick={() => track('clic-reseau-social', { reseau: 'instagram', source: 'footer' })}>Instagram</a>
      </div>
      <div className="footer-legal-links">
        <Link to="/mentions-legales">Mentions légales</Link>
        <span>·</span>
        <Link to="/politique-de-confidentialite">Politique de confidentialité</Link>
      </div>
      <p className="footer-copyright">
        © {new Date().getFullYear()} Lunetterie du Russey · Tous droits réservés
      </p>
    </div>
  </footer>
);
